import {Component, OnInit} from '@angular/core';
import {Router} from '@angular/router';
import {HttpParams} from '@angular/common/http';
import {TranslateService} from '@ngx-translate/core';
import {Grid} from '../../../../shared/Models/grid';
import {Column, DateColumn, TextColumn} from '../../../../shared/Models/columns';
import {BackOfficeOrderService} from '../../../Services/order.service';

/**
 * The chase list for POS insurance (US-606 D5): which insured orders can be registered with
 * the insurer, and which are still waiting on the dealer for the end customer's details.
 *
 * Read-only on purpose - the registration itself is completed by the dealer in the order
 * screen, so this page adds no editing of its own.
 */
@Component({
  selector: 'app-backoffice-pos-registration-overview',
  templateUrl: './backoffice-pos-registration-overview.component.html',
  styleUrls: ['./backoffice-pos-registration-overview.component.scss'],
})
export class BackofficePosRegistrationOverviewComponent implements OnInit {
  public grid: Grid;
  public params = new HttpParams();

  constructor(
    private readonly router: Router,
    private readonly translate: TranslateService,
    private readonly orderService: BackOfficeOrderService,
  ) {
  }

  ngOnInit() {
    const columns: Column[] = [
      <TextColumn>{
        name: this.translate.instant('admin.pos.grid.order_no'),
        prop: 'orderNo',
        sortable: true,
      },
      <TextColumn>{
        name: this.translate.instant('admin.pos.grid.dealer'),
        prop: 'dealer',
        sortable: false,
      },
      <TextColumn>{
        name: this.translate.instant('admin.pos.grid.term'),
        prop: 'posTerm',
        sortable: false,
      },
      // TextColumn, not NumberColumn (D11): the shared grid renders a NumberColumn as an
      // editable <input type="number">, and units are derived from the product's POS seating
      // units x quantity - never typed. Plain text keeps the decimals (0.5, 17.5) intact.
      <TextColumn>{
        name: this.translate.instant('admin.pos.grid.units'),
        prop: 'units',
        testId: 'pos-units',
        sortable: false,
      },
      <DateColumn>{
        name: this.translate.instant('admin.pos.grid.exported_at'),
        prop: 'exportedAt',
        type: DateColumn.type,
        format: 'DD-MM-YYYY',
        sortable: true,
      },
    ];

    this.grid = <Grid>{
      columns,
      service: this.orderService,
      rememberURL: this.router.url,
      method: 'getPosInsuredOrders',
      // The endpoint returns computed rows under `data`, not serialized Order entities.
      root: 'data',
      searchPlaceholder: 'search.about.order.no',
      defaultSort: 'id',
      defaultSortType: 'desc',
      showButton: false,
      doseNotHaveSearch: true,
    };
  }

  public setParams(params: HttpParams) {
    this.params = params;
  }
}
